import { Box, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import { resolve } from 'path-browserify';
import React from 'react'
import { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';
import readXlsFile from 'read-excel-file';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { Document, Page } from 'react-pdf';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

let dep = '';
let esc = '';
let ser = '';
let ent = '';
let sal = '';
let lug = '';
let vin = '';


class Pruebas extends Component {
    constructor(props){
        super(props);
        this.state = {
            consulta: {
                numeroFuncionario: '',
                anio: '',
                desde: '',
            },
            datosMov: null,
            notificaciones: null,
            errores: null,
            archivo: '',
            prueba: '',
            tipoPrueba: '',
            consultaPromedio: false,
            consultaAsiduidad: false,
            consultaSorteo: false,
            departamentos: [],
            sorteo: [],
            consultaMaria: false,

            archivosObligatorios: {
                acuerdo: '',
                convenio: '',
            },
        }
        this.manejarCambioNumFun = this.manejarCambioNumFun.bind(this);
        this.manejarEnvioConsulta = this.manejarEnvioConsulta.bind(this);
        this.manejarVolver = this.manejarVolver.bind(this);
        this.manejarEnvioCarga = this.manejarEnvioCarga.bind(this);
        this.manejarCambiosDatosArchivo = this.manejarCambiosDatosArchivo.bind(this);
        this.manejarEnvioArchivo = this.manejarEnvioArchivo.bind(this);
        this.manejarCambiosDatosPrueba = this.manejarCambiosDatosPrueba.bind(this);
        this.manejarCambiosDatosArchivoPDF = this.manejarCambiosDatosArchivoPDF.bind(this);
        this.manejarCambiosDatosDocObligatorios = this.manejarCambiosDatosDocObligatorios.bind(this);
    }

    async componentDidMount(){
        const departamento = await fetch(`${Constantes.RUTA_API}/obtener_departamentos.php`);
        const datoDepartamento = await departamento.json();
        this.setState({
            departamentos: datoDepartamento,
        });

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });

        const serie = await fetch(`${Constantes.RUTA_API}/obtener_series.php`);
        const datoSerie = await serie.json();
        this.setState({
            serieBase: datoSerie,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntrada: datosEntrada,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTrabajo: datoLugar,
        });

        const vin = await fetch(`${Constantes.RUTA_API}/obtener_vinculaciones.php`);
        const dat = await vin.json();
        this.setState({
            vinculacion: dat,
        });
    }


    render(){
        return (
            <>
            {sessionStorage.login && sessionStorage.tipoUsuario === '1'
            ?
                <Container>
                    <Box sx={{ flexGrow: 1}} style={{marginTop: '1rem'}}>
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={2}>

                            </Grid>
                            <Grid item xs={2.5}>
                                <Item>Prueba</Item>
                            </Grid>
                            <Grid item xs={2}>
                                <Item>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoPrueba' value={this.state.tipoPrueba} onChange={this.manejarCambiosDatosPrueba}>
                                        <option value={''}>TIPO PRUEBA</option>
                                        <option value={1}>CONSULTA DE ABATIMIENTO</option>
                                        <option value={2}>CARGA DE MOVIMIENTOS</option>
                                        <option value={3}>CARGA DE FUNCIONARIOS</option>
                                        <option value={4}>POMEDIOS MEDIA HORA</option>
                                        <option value={5}>CARGAR ANTIGÜEDAD PUBLICA</option>
                                        <option value={6}>ANTIGÜEDAD PARA PROMOCION</option>
                                        <option value={7}>CARGA CALIFICACIONES</option>
                                        <option value={8}>CARGA SUELDO BASE</option>
                                        <option value={9}>BUSQUEDA FUNCIONARIO</option>
                                        <option value={10}>CARGAR USUARIOS LOGIN</option>
                                        <option value={11}>CARGAR HORARIOS</option>
                                        <option value={12}>ASIDUIDAD</option>
                                        <option value={13}>CARGAR HORAS SIMPLES (DATOSGENERADOS)</option>
                                        <option value={14}>CARGAR HORAS PARA MARCAS</option>
                                        <option value={15}>CARGAR MOVIMIENTOS PERDIDOS (NO USAR SIN ANTES CONCULTAR)</option>
                                        <option value={16}>REALIZAR SORTEO (NO USAR SIN ANTES CONCULTAR)</option>
                                        <option value={17}>AGREGAR CAMBIOS CARGOS (NO USAR SIN ANTES CONCULTAR)</option>
                                        <option value={18}>Probando MariaDB</option>
                                        <option value={19}>Cargar PDF</option>
                                        <option value={20}>Cargar RETROACTIVOS (NO USAR SIN ANTES CONCULTAR)</option>
                                        <option value={21}>Pasar los Archivos a carpeta local (NO USAR SIN ANTES CONCULTAR)</option>
                                    </select>
                                </Item>
                            </Grid>
                        </Grid>
                    </Box>
                    {this.state.tipoPrueba === '1'
                    ?
                        <Container>
                            <Container>
                                <h3>Consulta de abatimientos de funcionarios</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={1}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Número Funcionario</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Item><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.consulta.numeroFuncionario} onChange={this.manejarCambioNumFun}/></Item>
                                        </Grid>
                                        <Grid item xs={1.5}>
                                            <Item>Año</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.consulta.anio} onChange={this.manejarCambioNumFun}/></Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioConsulta}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                            {this.state.datosMov
                            ?
                                <Container>
                                    <h3>Datos Movimientos</h3>
                                    <h6>Funcionario {this.state.datosMov[0].numeroFuncionario } {this.state.datosMov[0].nombreFuncionario}</h6>
                                    <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                        {this.state.datosMov[0].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR ENFERMEDAD</h6>
                                                <Table sx={{minWidth: 700}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Desde</StyledTableCell>
                                                            <StyledTableCell>Hasta</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[0].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[0].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>

                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[1].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR ENFERMEDAD FAMILIAR</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Desde</StyledTableCell>
                                                            <StyledTableCell>Hasta</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[1].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[1].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[2].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR ESTUDIO/EXAMEN</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Dias</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[2].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[2].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[3].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR EXTRAORDINARIA CON SUELDO</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[3].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[3].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[4].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR EXTRAORDINARIA SIN SUELDO</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[4].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[4].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[5].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS CON AVISO</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[5].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[5].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[6].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS SIN AVISO</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[6].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[6].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[7].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR SUSPENSION</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[7].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[7].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[8].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR MESA DE EXAMEN</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[8].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[8].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[9].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR ACCIDENTE TRABAJO BPS</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[9].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[9].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[10].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR INTERNACION FAMILIAR</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[10].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[10].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[11].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR ESTUDIO/PARCIAL</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[11].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[11].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[12].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR CERTIFICACION VIA ADMINISTRATIVA</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[12].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[12].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                        {this.state.datosMov[13].movimientos.length !== 0
                                        ?
                                            <Container>
                                                <br/>
                                                <h6>FALTAS POR SUBSIDIO TRANSITORIO BPS</h6>
                                                <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Días</StyledTableCell>
                                                            <StyledTableCell>Total</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.datosMov[13].movimientos.map((datoMov) => (
                                                            <StyledTableRow key={datoMov.idMovimiento}>
                                                                <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                <StyledTableCell></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableBody>
                                                        <StyledTableRow>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell></StyledTableCell>
                                                            <StyledTableCell>{this.state.datosMov[13].total}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableBody>
                                                </Table>
                                            </Container>
                                        :
                                            null
                                        }
                                    </TableContainer>
                                    <button className="btn btn-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarVolver}>Volver</button>
                                    <br/>
                                    <br/>
                                </Container>
                            :
                                null
                            }
                        </Container>
                    :
                        null
                    }

                    {this.state.tipoPrueba === '2'
                    ?
                        <Container>
                            <Container>
                                <h3>Carga de Movimientos de los funcionarios</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Cargar Excel</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                        </Grid>
                                        <Grid item xs={2}>
                                            
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                        </Container>
                    :
                        null
                    }

                    {this.state.tipoPrueba === '3'
                    ?
                        <Container>
                            <Container>
                                <h3>Carga de datos Funcionarios</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Cargar Excel</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                        </Grid>
                                        <Grid item xs={2}>
                                            
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '4'
                    ?
                        <Container>
                            <Container>
                                <h3>Promedio Media Hora</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Cargar Excel</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                        </Grid>
                                        <Grid item xs={2}>
                                            
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '5'
                    ?
                        <Container>
                            <Container>
                                <h3>Carga Antigüedad</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Cargar Excel</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                        </Grid>
                                        <Grid item xs={2}>
                                            
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '6'
                    ?
                        <Container>
                            <Container>
                                <h3>Antigüedad Para promociones</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Cargar Excel</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                        </Grid>
                                        <Grid item xs={5.5}>
                                            
                                        </Grid>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Año</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.consulta.anio} onChange={this.manejarCambioNumFun}/></Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                            <Container>
                                {this.state.consultaPromedio
                                ?
                                    <Container>
                                        <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                                        </ReactHtmlTableToExcel>
                                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell>Numero</StyledTableCell>
                                                    <StyledTableCell>Años</StyledTableCell>
                                                    <StyledTableCell>Meses</StyledTableCell>
                                                    <StyledTableCell>Días</StyledTableCell>
                                                    <StyledTableCell>Promociones</StyledTableCell>
                                                    <StyledTableCell>Grado</StyledTableCell>
                                                    <StyledTableCell>Calificacion {this.state.consulta.anio}</StyledTableCell>
                                                    <StyledTableCell>Calificacion {this.state.consulta.anio - 1}</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.datosMov.map((datoPro, index) => (
                                                    <StyledTableRow key={index}>
                                                        <StyledTableCell>{datoPro.numeroFuncionario}</StyledTableCell>
                                                        <StyledTableCell>{datoPro.anios}</StyledTableCell>
                                                        <StyledTableCell>{datoPro.meses}</StyledTableCell>
                                                        <StyledTableCell>{datoPro.dias}</StyledTableCell>
                                                        <StyledTableCell>{datoPro.promocion}</StyledTableCell>
                                                        <StyledTableCell>{datoPro.grado}</StyledTableCell>
                                                        <StyledTableCell>{datoPro.cal1}</StyledTableCell>
                                                        <StyledTableCell>{datoPro.cal2}</StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Container>
                                :
                                    null
                                }
                            </Container>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '7'
                    ?
                        <Container>
                            <Container>
                                <h3>Carga de Movimientos de los funcionarios</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Cargar Excel</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                        </Grid>
                                        <Grid item xs={2}>
                                            
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '8'
                    ?
                        <Container>
                            <Container>
                                <h3>Carga Sueldo Base</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Cargar Excel</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                        </Grid>
                                        <Grid item xs={5.5}>
                                            
                                        </Grid>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Desde</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item><input type='date' id='desde' value={this.state.consulta.desde} onChange={this.manejarCambioNumFun}/></Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '9'
                    ?
                        <Container>
                            <Container>
                                <h3>Busqueda Funcionarios</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Número Funcionario</Item>
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item><input type='number' id='numeroFuncionario' value={this.state.consulta.numeroFuncionario} onChange={this.manejarCambioNumFun}/></Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                            <Container>
                                {this.state.datosMov
                                ?
                                    <Container>
                                        <fieldset>
                                            <legend>DATOS PERSONALES</legend>
                                            <Box sx={{ flexGrow: 1}} >
                                                <Grid container spacing={2} rowSpacing={1}>
                                                    <Grid item xs={2.5}>
                                                        <Item>PRIMER NOMBRE</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.primerNombre}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>

                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>SEGUNDO NOMBRE</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.segundoNombre}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>PRIMER APELLIDO</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.primerApellido}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>SEGUNDO APELLIDO</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.segundoApellido}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>C.I.</Item>
                                                    </Grid>
                                                    {String(this.state.datosMov.ci).length === 8
                                                    ?
                                                        <Grid item xs={2}>
                                                            <Item>{String(this.state.datosMov.ci).substring(0,1)}.{String(this.state.datosMov.ci).substring(1,4)}.{String(this.state.datosMov.ci).substring(4,7)}-{String(this.state.datosMov.ci).substring(7,8)}</Item>
                                                        </Grid>
                                                    :
                                                        <Grid item xs={2}>
                                                            <Item>{String(this.state.datosMov.ci).substring(0,1)}.{String(this.state.datosMov.ci).substring(1,4)}.{String(this.state.datosMov.ci).substring(4,7)}</Item>
                                                        </Grid>
                                                    }
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>FECHA NACIMIENTO</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{String(this.state.datosMov.fechaNacimiento).substring(8,10) + '/' + String(this.state.datosMov.fechaNacimiento).substring(5,7) + '/' + String(this.state.datosMov.fechaNacimiento).substring(0,4)}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>CREDENCIAL</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.credencialSerie + ' ' + this.state.datosMov.credencialNumero}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>DIRECCION</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.direccionCalle + ' ' + this.state.datosMov.direccionNumero}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>LOCALIDAD</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.direccionLocalidad}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>DEPARTAMENTO</Item>
                                                    </Grid>
                                                    {this.state.departamentos.map((name2) => {
                                                        if(name2.idDepartamentos === this.state.datosMov.direccionDepartamento){
                                                            dep = name2.descripcion;
                                                        }
                                                    })}
                                                    <Grid item xs={2}>
                                                        <Item>{dep}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>TELEFONO</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.telefono}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>CELULAR</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.celular}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>CARNE DE SALUD</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{String(this.state.datosMov.carneSalud).substring(8,10) + '/' + String(this.state.datosMov.carneSalud).substring(5,7) + '/' + String(this.state.datosMov.carneSalud).substring(0,4)}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>SEXO</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        {this.state.datosMov.sexo === 0 ? <Item>MASCULINO</Item> : <Item>FEMENINO</Item> }
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </fieldset>
                                        <br/>
                                        <fieldset>
                                            <legend>DATOS FUNCIONARIO</legend>
                                            <Box sx={{ flexGrow: 1}} >
                                                <Grid container spacing={2} rowSpacing={1}>
                                                    <Grid item xs={2.5}>
                                                        <Item>NUMERO FUNCIONARIO</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.numeroFuncionario}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>FECHA DE INGRESO</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                    <Item>{String(this.state.datosMov.ingresoInstitucion).substring(8,10) + '/' + String(this.state.datosMov.ingresoInstitucion).substring(5,7) + '/' + String(this.state.datosMov.ingresoInstitucion).substring(0,4)}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>CARGO</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.cargo}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>ESCALAFON</Item>
                                                    </Grid>
                                                    {this.state.escalafones.map((name2) => {
                                                        if(name2.idEscalafon === this.state.datosMov.escalafon){
                                                            esc = name2.descripcion;
                                                        }
                                                    })}
                                                    <Grid item xs={2}>
                                                        <Item>{esc}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>GRADO</Item>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Item>{this.state.datosMov.grado}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>SERIE CONCURSO</Item>
                                                    </Grid>
                                                    {this.state.serieBase.map((name2) => {
                                                        if(name2.idSerie === this.state.datosMov.serieConcurso){
                                                            ser = name2.descripcion;
                                                        }
                                                    })}
                                                    <Grid item xs={2}>
                                                        <Item>{ser}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>HORARIO ENTRADA</Item>
                                                    </Grid>
                                                    {this.state.horasEntrada.map((name2) => {
                                                        if(name2.idEntrada === this.state.datosMov.horaEntrada){
                                                            ent = name2.descripcion;
                                                        }
                                                    })}
                                                    <Grid item xs={2}>
                                                        <Item>{ent}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>HORARIO SALIDA</Item>
                                                    </Grid>
                                                    {this.state.horasEntrada.map((name2) => {
                                                        if(name2.idEntrada === this.state.datosMov.horarioSalida){
                                                            sal = name2.descripcion;
                                                        }
                                                    })}
                                                    <Grid item xs={2}>
                                                        <Item>{sal}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>LUGAR DE TRABAJO</Item>
                                                    </Grid>
                                                    {this.state.lugaresTrabajo.map((name2) => {
                                                        if(name2.idLugaresTrabajo === this.state.datosMov.lugar){
                                                            lug = name2.lugar;
                                                        }
                                                    })}
                                                    <Grid item xs={2}>
                                                        <Item>{lug}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Item>VINCULACION</Item>
                                                    </Grid>
                                                    {this.state.vinculacion.map((name2) => {
                                                        if(name2.idVinculacion === this.state.datosMov.vinculacion){
                                                            vin = name2.descripcion;
                                                        }
                                                    })}
                                                    <Grid item xs={2}>
                                                        <Item>{vin}</Item>
                                                    </Grid>
                                                    <Grid item xs={0.5}>
                                                        
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            <br/>
                                        </fieldset>
                                    </Container>
                                :
                                    null
                                }
                            </Container>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '10'
                    ?
                        <Container>
                            <Container>
                                <h3>Carga Usuarios Login</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Cargar Excel</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '11'
                    ?
                        <Container>
                            <Container>
                                <h3>Cargar Horario</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Cargar Excel</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '12'
                    ?
                        <Container>
                            <Container>
                                <h3>ASIDUIDAD</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Año</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.consulta.anio} onChange={this.manejarCambioNumFun}/></Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                            <Container>
                                {this.state.consultaAsiduidad
                                ?
                                    <Container>
                                        <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                                        </ReactHtmlTableToExcel>
                                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell>Numero</StyledTableCell>
                                                        <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                                        <StyledTableCell>Fecha Ingreso</StyledTableCell>
                                                        <StyledTableCell>Enfermedad</StyledTableCell>
                                                        <StyledTableCell>Estudio/Examen</StyledTableCell>
                                                        <StyledTableCell>Extraordinaria S/Sueldo</StyledTableCell>
                                                        <StyledTableCell>Falta con Aviso</StyledTableCell>
                                                        <StyledTableCell>Falta Sin Aviso</StyledTableCell>
                                                        <StyledTableCell>Suspensión</StyledTableCell>
                                                        <StyledTableCell>Pase en Comisión</StyledTableCell>
                                                        <StyledTableCell>Estudio/Parcial</StyledTableCell>
                                                        <StyledTableCell>Subsidio Transitorio</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.datosMov.map((datoPro, index) => (
                                                        <StyledTableRow key={index}>
                                                            <StyledTableCell>{datoPro.numeroFuncionario}</StyledTableCell>
                                                            <StyledTableCell>{datoPro.nombreFuncionario}</StyledTableCell>
                                                            <StyledTableCell>{datoPro.fechaIngreso}</StyledTableCell>
                                                            <StyledTableCell>{datoPro.enfermedad}</StyledTableCell>
                                                            <StyledTableCell>{datoPro.estudioExamen}</StyledTableCell>
                                                            <StyledTableCell>{datoPro.extraSSueldo}</StyledTableCell>
                                                            <StyledTableCell>{datoPro.aviso}</StyledTableCell>
                                                            <StyledTableCell>{datoPro.sinAviso}</StyledTableCell>
                                                            <StyledTableCell>{datoPro.suspension}</StyledTableCell>
                                                            <StyledTableCell>{datoPro.paseComision}</StyledTableCell>
                                                            <StyledTableCell>{datoPro.estudioParcial}</StyledTableCell>
                                                            <StyledTableCell>{datoPro.subsTransBPS}</StyledTableCell>
                                                        </StyledTableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                    </Container>
                                :
                                    null
                                }
                            </Container>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '13'
                    ?
                        <Container>
                            <Container>
                                <h3>Cargar Horas Simples</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Cargar Excel</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                            </Container>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '14'
                    ?
                        <Container>
                            <h3>Cargar Horas Para Marcas</h3>
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Cargar Excel</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '15'
                    ?
                        <Container>
                            <h3>Cargar Movimientos Pendientes (Consultar antes de usar)</h3>
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Cargar Excel</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '16'
                    ?
                        <Container>
                            <h3>Realizar Sorteo (Consultar antes de usar)</h3>
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Cargar Excel</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '17'
                    ?
                        <Container>
                            <h3>Realizar Sorteo (Consultar antes de usar)</h3>
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={5}>

                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Realizar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '18'
                    ?
                        <Container>
                            <h3>Probando MariaDB</h3>
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={5}>

                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                    </Grid>
                                    {this.state.consultaMaria
                                    ?
                                        this.state.datosMov[0].leo
                                    :
                                        null
                                    }
                                </Grid>
                            </Box>
                            <br/>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '19'
                    ?
                        <Container>
                            <h3>Cargar PDF</h3>
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Cargar Excel</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivoPDF}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Realizar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '20'
                    ?
                        <Container>
                            <h3>Montos Retroactivos (Consultar antes de usar)</h3>
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Cargar Excel</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Consultar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                            <input type="file" style={{border: "2px solid #D6EAF8", width: "100%", marginTop: '1rem'}} id='acuerdo' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                            <input type="file" style={{border: "2px solid #D6EAF8", width: "100%", marginTop: '1rem'}} id='convenio' onChange={this.manejarCambiosDatosDocObligatorios} accept=".pdf"/>
                            <br/>
                        </Container>
                    :
                        null
                    }
                    {this.state.tipoPrueba === '21'
                    ?
                        <Container>
                            <h3>Pasar los Archivos a carpeta local (Consultar antes de usar)</h3>
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={5}>

                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Realizar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                        </Container>
                    :
                        null
                    }
                    {this.state.consultaSorteo
                    ?
                        <Container>
                            <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                            </ReactHtmlTableToExcel>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>ID</StyledTableCell>
                                            <StyledTableCell>CI</StyledTableCell>
                                            <StyledTableCell>NOMBRES</StyledTableCell>
                                            <StyledTableCell>APELLIDOS</StyledTableCell>
                                            <StyledTableCell>CORREO</StyledTableCell>
                                            <StyledTableCell>TEL</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.sorteo.map((name, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell>{name.id}</StyledTableCell>
                                                <StyledTableCell>{name.ci}</StyledTableCell>
                                                <StyledTableCell>{name.nombre}</StyledTableCell>
                                                <StyledTableCell>{name.apellido}</StyledTableCell>
                                                <StyledTableCell>{name.mail}</StyledTableCell>
                                                <StyledTableCell>{name.cel}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    :
                        null
                    }
                </Container>
            :
                <Redirect to='/login'/>
            }
            </>
        )//Final return
    }//Final render

    manejarCambioNumFun(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState( state => {
            const consAct = state.consulta;
            consAct[clave] = valor;
            return{
                consulta: consAct,
            };
        });

        this.setState({
            errores: null,
            notificaciones: null,
        });
    }

    manejarCambiosDatosArchivoPDF(e){
        e.preventDefault();
        let valor = e.target.files[0];
        this.setState({
            archivo: valor,
        })
    }

    async manejarEnvioConsulta(e){
        e.preventDefault();
        if(this.state.consulta.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario!',
            })
        }else if(this.state.consulta.anio === ''){
            this.setState({
                errores: 'Debe ingresar el año!',
            })
        }else{
            const cargaUtil = JSON.stringify(this.state.consulta);

            const control = await fetch(`${Constantes.RUTA_API}/obtener_abatimientoCalificacion.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
            });
            if(res[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    datosMov: res[1],
                })
            }
        }
    }

    manejarVolver(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            datosMov: null,
            consulta: {
                numeroFuncionario: '',
                anio: '',
                desde: '',
            }
        });
    }

    async manejarEnvioCarga(e){
        e.preventDefault();

        const control = await fetch(`${Constantes.RUTA_API}/cargar_excel.php`);
        const res = await control.json();

        this.setState({
            errores: res[0],
        });

        
        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                datosMov: res[1],
            })
        }
    }

    manejarCambiosDatosArchivo(e){
        e.preventDefault();
        let valor = e.target.files[0];
        readXlsFile(valor).then((rows) => {
            this.setState({
                archivo: rows,
                prueba: rows[1],
            })
        });
        /*const clave = e.target.id;
        let valor = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (e) => {
            e.preventDefault();
            this.setState({
                archivo: e.target.result,
                errores: null,
                notificaciones: null,
            })
        };*/
    }

    async manejarEnvioArchivo(e){
        e.preventDefault();
        if(this.state.tipoPrueba === '18'){

            const cargaUtil = JSON.stringify([0]);

            const control = await fetch(`${Constantes.RUTA_API}/pruebaMariaDB.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                datosMov: res,
                consultaMaria: true,
            })
            
        }else{
            const cargaUtil = JSON.stringify([this.state.archivo, this.state.tipoPrueba, this.state.consulta.anio, this.state.consulta.desde, this.state.consulta.numeroFuncionario, this.state.archivosObligatorios]);

            const control = await fetch(`${Constantes.RUTA_API}/cargar_excel.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
            });
            if(res[0] === 'ok'){
                if(this.state.tipoPrueba === '4'){
                    this.setState({
                        errores: null,
                        notificaciones: 'Promedio ' + res[2] + ' datos',
                        datosMov: res[1],
                    });
                }else if(this.state.tipoPrueba === '6'){
                    this.setState({
                        errores: null,
                        notificaciones: null,
                        datosMov: res[1],
                        consultaPromedio: true,
                    });
                }else if(this.state.tipoPrueba === '9'){
                    this.setState({
                        errores: null,
                        notificaciones: null,
                        datosMov: res[1],
                        consultaPromedio: true,
                    });
                }else if(this.state.tipoPrueba === '12'){
                    this.setState({
                        errores: null,
                        notificaciones: null,
                        datosMov: res[1],
                        consultaAsiduidad: true,
                    });
                }else if(this.state.tipoPrueba === '16'){
                    this.setState({
                        errores: null,
                        notificaciones: 'Total de personas sorteadas: ' + res[1],
                        datosMov: res[1],
                        sorteo: res[2],
                        consultaAsiduidad: false,
                        consultaSorteo: true,
                    });
                }else{
                    this.setState({
                        errores: null,
                        notificaciones: 'Carga completa de ' + res[1] + ' datos',
                        datosMov: res[1],
                    });
                }
            }
        }
    }

    manejarCambiosDatosPrueba(e){
        e.preventDefault();
        let valor = e.target.value;
        this.setState({
            notificaciones: null,
            errores: null,
            datosMov: null,
            tipoPrueba: valor,
        });
    }

    async manejarCambiosDatosDocObligatorios(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor;
        valor = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (e) => {
            e.preventDefault();
            this.setState(state => {
                const movimientosActualizado = state.archivosObligatorios;
                movimientosActualizado[clave] = e.target.result;
                return{
                    archivosObligatorios: movimientosActualizado,
                };
            });
        };
    }
}

export default Pruebas